import * as React from 'react';
import * as ResizablePrimitive from 'react-resizable-panels';

// Closed split-pane primitive — wraps `react-resizable-panels`. The
// caller composes <ResizablePanelGroup direction>{<ResizablePanel
// size={n}>{...}</ResizablePanel><ResizableHandle><Separator
// orientation="vertical"/></ResizableHandle>...</ResizablePanelGroup>}.
//
// `ResizablePanel` exposes `size` (initial percentage, was Radix's
// defaultSize) and an optional `minSize`. With two panels in a group,
// the maximum of one is implicitly `100 - minSize` of the other —
// no explicit `maxSize` axis until a real callsite needs one.
//
// `ResizableHandle` accepts `children` for the visible handle decoration
// (Separator, Icon, anything). The bar itself is the click/drag target;
// children sit on top, centred, and auto-rotate 90deg when the parent
// group is vertical so directional decorations work in either orientation.

const PANEL_GROUP_CLASSNAME = 'tw-flex tw-h-full tw-w-full data-[panel-group-direction=vertical]:tw-flex-col';

const HANDLE_CLASSNAME = 'tw-relative tw-flex tw-w-px tw-items-center tw-justify-center tw-bg-border after:tw-absolute after:tw-inset-y-0 after:tw-left-1/2 after:tw-w-1 after:tw--translate-x-1/2 focus-visible:tw-outline-none focus-visible:tw-ring-1 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-1 data-[panel-group-direction=vertical]:tw-h-px data-[panel-group-direction=vertical]:tw-w-full data-[panel-group-direction=vertical]:after:tw-left-0 data-[panel-group-direction=vertical]:after:tw-h-1 data-[panel-group-direction=vertical]:after:tw-w-full data-[panel-group-direction=vertical]:after:tw--translate-y-1/2 data-[panel-group-direction=vertical]:after:tw-translate-x-0 [&[data-panel-group-direction=vertical]>*]:tw-rotate-90';

const ResizablePanelGroup = ({ children, className: _className, style: _style, direction = 'horizontal' }) => (
    <ResizablePrimitive.PanelGroup className={PANEL_GROUP_CLASSNAME} direction={direction}>
        {children}
    </ResizablePrimitive.PanelGroup>
);

const ResizablePanel = ({ children, className: _className, style: _style, minSize, size }) => (
    <ResizablePrimitive.Panel defaultSize={size} minSize={minSize}>
        {children}
    </ResizablePrimitive.Panel>
);

const ResizableHandle = ({ children, className: _className, style: _style }) => (
    <ResizablePrimitive.PanelResizeHandle className={HANDLE_CLASSNAME}>
        {children}
    </ResizablePrimitive.PanelResizeHandle>
);

export { ResizablePanelGroup, ResizablePanel, ResizableHandle };
